import { render, staticRenderFns } from "./ClientRegistrationFinish.vue?vue&type=template&id=47e9166e&scoped=true&"
import script from "./ClientRegistrationFinish.vue?vue&type=script&lang=js&"
export * from "./ClientRegistrationFinish.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegistrationFinish.vue?vue&type=style&index=0&id=47e9166e&prod&lang=scss&"
import style1 from "./ClientRegistrationFinish.vue?vue&type=style&index=1&id=47e9166e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e9166e",
  null
  
)

export default component.exports